import {
    EmailConfirmedModalHeaderStyled,
    EmailConfirmedModalIconContainerStyled
} from "../../Modals/EmailConfirmedModal/styled/EmailConfirmedModalStyled";
import { BinIcon } from "../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import { useLocation } from "react-router";
import { createStructuredSelector } from "reselect";
import { getAppUser } from "../../../app/appSelectors";
import { appInitAction } from "../../../app/appActions";
import { connect } from "react-redux";
import { Fragment, useEffect } from "react";

function EmailConfirmed(props) {
    const {appInitAction, ButtonWrapperComponent = Fragment, handleButtonClick, user} = props;
    const {getLangPath} = useLangContext();
    const location = useLocation();

    useEffect(() => {
        if (!user.email_confirmed && location.state?.checkEmail === user.email) {
            appInitAction();
        }
    }, [appInitAction, location, user.email_confirmed, user.email]);

    return <>
        <EmailConfirmedModalIconContainerStyled className="mt-3">
            <BinIcon name="IcEnvelopeCheckmark"/>
        </EmailConfirmedModalIconContainerStyled>
        <EmailConfirmedModalHeaderStyled className="mb-0 mt-2rem">
            {getLangPath('sign_up.email_confirmed_title')}
        </EmailConfirmedModalHeaderStyled>
        <p className="mb-0 mt-3">
            {getLangPath('sign_up.email_confirmed_description')}
        </p>
        <div className="d-flex flex-column w-100 mt-2rem">
            <ButtonWrapperComponent>
                <Button
                    size={'lg'}
                    variant="primary"
                    onClick={handleButtonClick}
                >
                    {getLangPath('sign_up.email_confirmed_button')}
                </Button>
            </ButtonWrapperComponent>
        </div>
    </>
}

const mapStateToProps = createStructuredSelector({
    user: getAppUser,
});

const mapDispatchToProps = {
    appInitAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmed);
